<script>
import { mapGetters } from 'vuex';
import { FILTER_ITEM_MAX_LENGTH } from './helpers/constant';

import Avatar from 'next/avatar/Avatar.vue';
import WootDropdownItem from 'shared/components/ui/dropdown/DropdownItem.vue';
import WootDropdownMenu from 'shared/components/ui/dropdown/DropdownMenu.vue';

export default {
  components: {
    WootDropdownItem,
    WootDropdownMenu,
    Avatar,
  },
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add'],
  computed: {
    ...mapGetters({
      contacts: 'contacts/getContacts',
    }),
    searchedContacts() {
      return this.contacts
        .filter(contact => {
          return !this.selectedIds.includes(contact.id);
        })
        .slice(0, FILTER_ITEM_MAX_LENGTH);
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    async setDefaults() {
      try {
        const requestParams = {
          // page,
          // sortAttr: this.getSortAttribute(),
          // label: this.label,
        };
        await this.$store.dispatch('contacts/get', requestParams);
      } catch {
        // ignore error
      } finally {
        this.initializing = false;
      }
    },
    isActive(contact) {
      return this.selectedIds.some(selectedId => selectedId === contact.id);
    },
    onClick(contact) {
      this.$emit('add', contact);
    },
  },
};
</script>

<template>
  <div>
    <label
      v-if="!searchedContacts.length"
      class="text-xs italic text-center mt-2 text-slate-600 dark:text-slate-400"
    >
      {{
        $t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.CONTACTS.MULTI_SELECTOR.NO_RESULT')
      }}
    </label>
    <WootDropdownMenu>
      <WootDropdownItem v-for="contact in searchedContacts" :key="contact.id">
        <button
          class="inline-flex items-center justify-start w-full h-8 min-w-0 gap-2 px-2 py-1.5 transition-all duration-200 ease-in-out border-0 rounded-lg z-60 hover:bg-n-alpha-1 dark:hover:bg-n-alpha-2 disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50 text-n-slate-12"
          @click="onClick(contact)"
          @keydown.enter="onClick(contact)"
        >
          <slot name="thumbnail" :item="contact">
            <Avatar
              :name="contact.name"
              :src="contact.thumbnail"
              :size="20"
              rounded-full
            />
          </slot>
          <span v-if="contact.name" class="min-w-0 text-sm truncate">{{
            contact.name
          }}</span>
        </button>
      </WootDropdownItem>
    </WootDropdownMenu>
    <label
      v-if="selectedIds.length"
      class="text-sm mt-2 text-slate-600 dark:text-slate-400"
    >
      {{ $t('WGPT_BOARDS.FILTER.CONTACTS.SELECTED_CONTACTS') }}
    </label>
  </div>
</template>
